import PageLoadedQueue
    from "../../../../../../../Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/PageLoadedQueue";
import {initArticleBuy, ActionBuyEventInterface}
    from "../../../../../../../Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/Plugins/ArticleBuy";

export function loadArticleDiscountPromotionHeader(promotionHeader: HTMLElement) {
    /**
     * Sort the list items by price
     *
     * @param list
     * @param items
     * @param limit
     */
    const sortItems = (list: HTMLElement, items: NodeListOf<HTMLElement>, limit: number = 2) => {
        const itemsArray = Array.from(items);

        itemsArray.sort((a, b) => {
            const priceA = parseFloat(a.dataset.articlePromotionPrice);
            const priceB = parseFloat(b.dataset.articlePromotionPrice);

            return priceA - priceB;
        });

        itemsArray.forEach((item) => {
            list.appendChild(item);
        });

        // limit items
        const itemsToHide = itemsArray.slice(limit);
        itemsToHide.forEach((item) => {
            item.classList.add('d-none');
        });
    }

    /**
     * Attach the load more event to the variant button
     * Shows the variant overlay when the load more button is clicked
     *
     * @param variantButton
     * @param loadMoreButton
     */
    const attachLoadMoreToVariantButton = (variantButton: HTMLButtonElement, loadMoreButton: HTMLLinkElement) => {
        loadMoreButton.addEventListener('click', () => {
            variantButton.click();
        }, {passive: true});
    }

    /**
     * Move the load more item to the bottom of the list
     * Attach the load more event to the variant button
     * Removes the load more item if there are not enough items or the variant button is not available
     *
     * @param list
     */
    const moveLoadMoreToBottom = (list: HTMLElement) => {
        const items = list.querySelectorAll('.article-promotion-item') as NodeListOf<HTMLElement>;
        const loadMoreItem = list.querySelector('.article-promotion-item-load-more') as HTMLElement;

        if (loadMoreItem) {
            const articleHeader = list.closest('.article-header') as HTMLElement;
            if (!articleHeader) {
                loadMoreItem.remove();
            }

            const variantButton = articleHeader.querySelector('.article-variants-action-btn') as HTMLButtonElement;
            if (!variantButton) {
                loadMoreItem.remove();
            }

            if (items.length > 2) {
                list.appendChild(loadMoreItem);
                loadMoreItem.classList.remove('d-none');

                attachLoadMoreToVariantButton(variantButton, loadMoreItem.querySelector('.article-promotion-item-link') as HTMLLinkElement);
                return;
            }

            loadMoreItem.remove();
        }
    }

    /**
     * Show the list and remove the loading spinner
     * Remove the promotion header if there are no items
     *
     * @param list
     * @param loadingSpinner
     * @param items
     * @param promotionHeader
     */
    const showList = (list: HTMLElement, loadingSpinner: HTMLElement, items: NodeListOf<HTMLElement>, promotionHeader: HTMLElement) => {
        list.classList.remove('d-none');
        loadingSpinner.remove();

        if (items.length === 0) {
            promotionHeader.remove();
        }
    }

    /**
     * Event listener for the list loaded event
     *
     * @param promotionHeader
     */
    const listLoadedEventListener = (promotionHeader: HTMLElement) => {
        const items = itemList.querySelectorAll('.article-promotion-item[data-article-promotion-price]') as NodeListOf<HTMLElement>;

        sortItems(itemList, items, 2);
        moveLoadMoreToBottom(itemList);
        showList(itemList, loadingSpinner, items, promotionHeader);
    }

    /**
     * Event listener for the data loaded event
     * Add the price to the item
     * Remove the item if it is not an action price
     *
     * @param item
     * @param e
     */
    const addPriceToItemEventListener = (item: HTMLElement, e: ActionBuyEventInterface) => {
        // Remove item if it is not an action price
        if (!e.detail.price?.isActionPrice) {
            item.remove();

            return;
        }

        item.dataset.articlePromotionPrice = e.detail.price.unitPrice;
    }

    const itemList = promotionHeader.querySelector('ul.list-unstyled') as HTMLElement;
    const loadingSpinner = promotionHeader.querySelector('.article-promotion-header-loading-spinner') as HTMLElement;
    const items = itemList.querySelectorAll('.article-promotion-item[data-article-buy-item-id]') as NodeListOf<HTMLElement>;

    initArticleBuy(items, promotionHeader);

    items.forEach((item) => {
        item.addEventListener('Plandent.ArticleBuy.DataLoaded', addPriceToItemEventListener.bind(null, item), {passive: true});
    })

    promotionHeader.addEventListener('Plandent.ArticleBuy.DataLoadedAll', listLoadedEventListener.bind(null, promotionHeader), {passive: true});

    // Remove the promotion header if all items failed to load
    promotionHeader.addEventListener('Plandent.ArticleBuy.FailedAll', () => {
        promotionHeader.remove();
    }, {passive: true});
}

PageLoadedQueue.addFunction(() => {
    const promotionHeader = document.querySelector('.article-promotion-header-card') as HTMLElement;
    if (!promotionHeader) {
        return;
    }

    loadArticleDiscountPromotionHeader(promotionHeader);
});
